import {
  CAMPAIGN_TYPE_FILTER_CHANGE,
  CANCEL_CAMPAIGN_ASYNC,
  CHANGE_SELECTION_DATA,
  COPY_CAMPAIGN_ASYNC,
  DATA_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  DELETE_CAMPAIGN_ASYNC,
  END_CAMPAIGN_ASYNC,
  GET_RECOMMENDED_CAMPAIGNS,
  LANGUAGES_FILTER_CHANGE,
  PAGINATE_CHANGE,
  RESET_FILTERS,
  RESET_RECOMMENDED_PREVIEW_DATA,
  SAVE_DRAFT_ASYNC,
  SEARCH_CHANGE,
  SET_RECOMMENDED_PREVIEW_DATA,
  SORT_PROPERTY_CHANGE,
  STATUS_FILTER_CHANGE,
} from './constants'

export const fetchCampaigns = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
const fetchCampaignsCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })
export const fetchCampaignsSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchCampaignsError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})

export const copyCampaign = (id, companiesIds) => ({
  type: COPY_CAMPAIGN_ASYNC.INITIATE,
  payload: { id, companiesIds },
})
export const copyCampaignSuccess = () => ({ type: COPY_CAMPAIGN_ASYNC.SUCCESS })
export const copyCampaignError = (error) => ({
  type: COPY_CAMPAIGN_ASYNC.ERROR,
  error,
})

export const cancelCampaign = (id) => ({
  type: CANCEL_CAMPAIGN_ASYNC.INITIATE,
  payload: { id },
})
export const cancelCampaignSuccess = () => ({
  type: CANCEL_CAMPAIGN_ASYNC.SUCCESS,
})
export const cancelCampaignError = (error) => ({
  type: CANCEL_CAMPAIGN_ASYNC.ERROR,
  error,
})

export const endCampaign = (id) => ({
  type: END_CAMPAIGN_ASYNC.INITIATE,
  payload: { id },
})
export const endCampaignSuccess = () => ({ type: END_CAMPAIGN_ASYNC.SUCCESS })
export const endCampaignError = (error) => ({
  type: END_CAMPAIGN_ASYNC.ERROR,
  error,
})

export const deleteCampaign = (id) => ({
  type: DELETE_CAMPAIGN_ASYNC.INITIATE,
  payload: { id },
})
export const deleteCampaignSuccess = () => ({
  type: DELETE_CAMPAIGN_ASYNC.SUCCESS,
})
export const deleteCampaignError = (error) => ({
  type: DELETE_CAMPAIGN_ASYNC.ERROR,
  error,
})

export const getRecommendedCampaigns = () => ({
  type: GET_RECOMMENDED_CAMPAIGNS.INITIATE,
})
export const getRecommendedCampaignsSuccess = (data) => ({
  type: GET_RECOMMENDED_CAMPAIGNS.SUCCESS,
  payload: { data },
})
export const getRecommendedCampaignsError = (error) => ({
  type: GET_RECOMMENDED_CAMPAIGNS.ERROR,
  error,
})
export const getRecommendedCampaignsCancel = () => ({
  type: GET_RECOMMENDED_CAMPAIGNS.CANCEL,
})

export const saveDraft = (id, defaultLocaleId) => ({
  type: SAVE_DRAFT_ASYNC.INITIATE,
  payload: { id, defaultLocaleId },
})

export const saveDraftSuccess = (id) => ({
  type: SAVE_DRAFT_ASYNC.SUCCESS,
  payload: { id },
})

export const saveDraftError = (error) => ({
  type: SAVE_DRAFT_ASYNC.ERROR,
  payload: { error },
})

export const sortPropertyChange = (value) => ({
  type: SORT_PROPERTY_CHANGE,
  payload: { value },
})
export const setRecommendedPreviewData = (data) => ({
  type: SET_RECOMMENDED_PREVIEW_DATA,
  payload: { data },
})
export const resetRecommendedPreviewData = () => ({
  type: RESET_RECOMMENDED_PREVIEW_DATA,
})
export const campaignTypeFilterChange = (campaignTypeArray) => ({
  type: CAMPAIGN_TYPE_FILTER_CHANGE,
  payload: { campaignTypeArray },
})
export const languagesFilterChange = (languagesArray) => ({
  type: LANGUAGES_FILTER_CHANGE,
  payload: { languagesArray },
})
export const statusFilterChange = (statusArray) => ({
  type: STATUS_FILTER_CHANGE,
  payload: { statusArray },
})
export const dateFilterChange = (dateFilter) => ({
  type: DATE_FILTER_CHANGE,
  payload: { dateFilter },
})
export const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })
export const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
export const resetFilters = () => ({ type: RESET_FILTERS })
export const changeSelectionData = (field, value) => ({
  type: CHANGE_SELECTION_DATA,
  payload: { field, value },
})

export default {
  // to props
  fetchCampaigns,
  fetchCampaignsCancel,
  statusFilterChange,
  dateFilterChange,
  campaignTypeFilterChange,
  languagesFilterChange,
  searchChange,
  deleteCampaign,
  getRecommendedCampaigns,
  setRecommendedPreviewData,
  resetRecommendedPreviewData,
  saveDraft,
  getRecommendedCampaignsCancel,
}
